import React, { useCallback } from 'react';
import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme } from '@apply/components';

export const PanelDemo: React.FC<{}> = ({}) => {
    const handleDivClick: React.MouseEventHandler = useCallback(() => {
        alert('Div clicked!');
    }, []);

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Panels :</h2>
            <br />
            <Panel
                theme={PanelTheme.Blue}
                borderRadius={PanelBorderRadius.Medium}
            >
                Blue Panel
            </Panel>
            <Panel
                theme={PanelTheme.White}
                borderRadius={PanelBorderRadius.Medium}
            >
                White Panel
            </Panel>
            <Panel
                theme={PanelTheme.Red}
                borderRadius={PanelBorderRadius.Medium}
            >
                Red Panel
            </Panel>
            <Panel
                theme={PanelTheme.Gray}
                borderRadius={PanelBorderRadius.Medium}
                borderStyle={PanelBorderStyle.Solid}
            >
                Gray Panel
            </Panel>
            <Panel
                theme={PanelTheme.Yellow}
                borderRadius={PanelBorderRadius.Medium}
                borderStyle={PanelBorderStyle.Solid}
            >
                Yellow Panel
            </Panel>
            <Panel
                theme={PanelTheme.Blue}
                borderRadius={PanelBorderRadius.Medium}
            >
                Panel With Sub Panels
                <br />
                <br />
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    Item 1
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    Item 2
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    Item 3
                </Panel>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Medium}
                    handleClick={handleDivClick}
                >
                    Item 4
                </Panel>
            </Panel>
        </div>
    );
};
